var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40.9 25.9",
    style: {
      enableBackground: "new 0 0 40.9 25.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DEDEDE;}\n\t.st1{fill:#0039AF;}\n\t.st2{fill:#FFB700;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.5,25.3H3.3c-1.4,0-2.5-1.1-2.5-2.5V3.1c0-1.4,1.1-2.5,2.5-2.5h34.2c1.4,0,2.5,1.1,2.5,2.5v19.6 C40.1,24.2,38.9,25.3,37.5,25.3z M3.3,1.4c-0.9,0-1.7,0.8-1.7,1.7v19.6c0,0.9,0.8,1.7,1.7,1.7h34.2c0.9,0,1.7-0.8,1.7-1.7V3.1 c0-0.9-0.8-1.7-1.7-1.7H3.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.8,8.4c-2.3,0-3.8,1.2-3.9,2.9c0,1.3,1.1,2,2,2.4c0.9,0.4,1.2,0.7,1.2,1.1c0,0.6-0.7,0.9-1.4,0.9 c-0.9,0-1.4-0.1-2.1-0.5l-0.3-0.1L20,17c0.5,0.2,1.5,0.5,2.5,0.5c2.4,0,4-1.2,4-3c0-1-0.6-1.8-1.9-2.4c-0.8-0.4-1.3-0.7-1.3-1.1 c0-0.4,0.4-0.8,1.3-0.8c0.7,0,1.3,0.2,1.7,0.3l0.2,0.1l0.3-1.9C26.4,8.6,25.7,8.4,24.8,8.4L24.8,8.4z M17.7,8.5l-1.4,8.9h2.3 L20,8.5L17.7,8.5L17.7,8.5z M14.3,8.5l-2.2,6l-0.2-1.2c-0.6-1.5-1.8-3.1-3.2-3.7l2,7.7l2.4,0l3.6-8.8L14.3,8.5L14.3,8.5z  M30.9,8.5c-0.5,0-1,0.2-1.2,0.7l-3.4,8.1h2.4c0,0,0.4-1.1,0.5-1.3c0.3,0,2.6,0,2.9,0c0.1,0.3,0.3,1.3,0.3,1.3h2.1l-1.9-8.8 L30.9,8.5L30.9,8.5z M31.1,10.9l0.2,0.8c0,0,0.4,2.1,0.5,2.6h-1.9c0.2-0.5,0.9-2.5,0.9-2.5C30.8,11.8,31,11.3,31.1,10.9L31.1,10.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10,8.5H6.3l0,0.2c2.9,0.7,4.8,2.5,5.5,4.7l-0.8-4.1C10.9,8.7,10.5,8.6,10,8.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b8a133de2163177497898fb89664d836.svg";
export { ForwardRef as ReactComponent };